var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DandisetsPage',{attrs:{"title":"My Dandisets","user":""},scopedSlots:_vm._u([{key:"no-content",fn:function(){return [_c('div',[_vm._v(" You haven't created any dandisets yet ")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }